// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Z8lLhD4OZOM0W2ta{display:flex;flex-direction:column;justify-content:space-between;height:100%}.Z8lLhD4OZOM0W2ta .ClyWR2FlRM9rmslA{width:100%;height:248px;display:grid;place-items:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartContainer": `Z8lLhD4OZOM0W2ta`,
	"factorsPolygon": `ClyWR2FlRM9rmslA`
};
export default ___CSS_LOADER_EXPORT___;
